import { api } from './api';

export async function deleteEmail(emailId: string): Promise<boolean> {
  const response = await api.delete(`emails/${emailId}`);
  return response.status === 204;
}
